import { render, staticRenderFns } from "./NewSeguridad.vue?vue&type=template&id=18e3d88c&scoped=true&"
import script from "./NewSeguridad.vue?vue&type=script&lang=ts&"
export * from "./NewSeguridad.vue?vue&type=script&lang=ts&"
import style0 from "./NewSeguridad.vue?vue&type=style&index=0&id=18e3d88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e3d88c",
  null
  
)

export default component.exports